import ResImagesSkeleton from "./ResImagesSkeleton";
import InfographySkeleton from "./InfographySkeleton";

function TopSectionSkeleton() {
  return (
    <>
      <div className="mb-24 md:mb-0 md:mt-24">
        <ResImagesSkeleton />
      </div>

      <InfographySkeleton />
    </>
  );
}

export default TopSectionSkeleton;
